<template>
    <div>
        <span style="padding-right: 5px;">月份選擇:</span>
        <el-select
                placeholder="請選擇月份"
                v-model="month"
                style="margin-right: 5px;"
                @change="onMonthChange"
        >
            <el-option
                    v-for="month in availableMonths"
                    :key="month"
                    :label="month"
                    :value="month"
            ></el-option>
        </el-select>
        <el-button
                icon="el-icon-refresh-right"
                @click="refresh"
                :loading="loading"

        >
            重新載入
        </el-button>

        <el-table
                :stripe="true"
                :data="pagedForms"
                empty-text="本學期無表單"
                height="610px"
                row-key="idx"
        >
            <el-table-column
                    label="#"
                    prop="idx"
                    width="50">
            </el-table-column>
            <el-table-column
                    label="申請時間"
                    prop="createdAt"
            ></el-table-column>
            <el-table-column
                    label="類型"
                    prop="type"
            >
                <template #default="{row}">
                    {{getFormTypeStr(row.type)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="場地"
            >
                <template #default="{row}">
                    {{roomName(row)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="申請人"
            >
                <template #default="{row}">
                    {{row.applicant.name}} ({{row.applicant.shortDepartmentName}})
                </template>
            </el-table-column>
            <el-table-column
                    label="目前狀態"
                    prop="status"
            ></el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            type="primary"
                            size="small"
                            @click="showManualDialog(row)"
                    >
                        手動設定場地
                    </el-button>
                    <el-button
                            type=""
                            @click="selectAndShow(row)"
                            size="small"
                    >
                        詳細
                    </el-button>

                    <el-button
                            type="info"
                            size="small"
                            @click="showMailDialog(row)"
                            :disabled="row.isNoDrewMailSend"
                    >
                        {{row.isNoDrewMailSend ? '已寄送' : '寄送通知信'}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="forms.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, forms)"
                :current-page.sync="currentPage"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                :title="title"
                top="5vh"
                v-if="show"
        >
            <drawable-form
                    :form="selectedForm"
            ></drawable-form>
            <template #footer>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
        <el-dialog
                :visible.sync="showMail"
                :title="`${applicant}-未中籤通知`"
                top="5vh"
                @opened="onMailDialogOpened"
                @closed="onMailDialogClosed"
        >
            <el-form
                    ref="mailForm"
                    :model="mailForm"
                    label-width="150px"
                    :rules="mailRules"
            >
                <el-form-item prop="subject" label="主旨">
                    <el-input v-model="mailForm.subject" placeholder="請輸入主旨"></el-input>
                </el-form-item>
                <el-form-item prop="content" label="內文">
                    <vue-editor
                            v-model="mailForm.content" style="font-size: initial;line-height: initial;"
                            :editorToolbar="customToolbar"
                    ></vue-editor>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="onSendMail" :loading="loading">送出</el-button>
                <el-button @click="closeMailDialog">取消</el-button>
            </template>
        </el-dialog>
        <el-dialog
                :visible.sync="showManual"
                :title="`${applicant}-手動設定中籤場地`"
                top="5vh"
                width="800px"
                @closed="onManualDialogClosed"
        >
            <span style="padding-right: 5px;">日期:</span>
            <el-select
                    placeholder="請選擇日期"
                    v-model="selectedDate"
                    @change="onSelectDate"
            >
                <el-option
                        v-for="date in Object.keys(availablePeriods)"
                        :key="date"
                        :value="date"
                        :label="date"
                ></el-option>
            </el-select>
            <span style="padding-right: 5px;padding-left: 5px;">時段:</span>
            <el-select
                    multiple
                    placeholder="請選擇時段"
                    v-model="selectedPeriods"
                    style="margin-right: 5px;"
            >
                <el-option
                        v-for="p in selectablePeriods"
                        :key="fakeId(p)"
                        :value="fakeId(p)"
                        :label="`${p.roomName}-${p.tag}`"
                ></el-option>
            </el-select>
            <el-button
                    icon="el-icon-plus"
                    type="success"
                    @click="onAdd"
            >加入
            </el-button>
            <el-divider>結果</el-divider>
            <el-table
                    :data="manualResults"
                    empty-text="尚無資料"
                    strip
            >
                <el-table-column
                        label="日期"
                        prop="date"
                ></el-table-column>
                <el-table-column
                        label="場地"
                        prop="drew"
                ></el-table-column>
            </el-table>
            <template #footer>
                <el-button type="primary" @click="onAddSubmit" :loading="loading">送出</el-button>
                <el-button @click="closeManualDialog">取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import formTableMixin from '../../formTableMixin';
    import {VueEditor} from 'vue2-editor';

    const defaultMail = {
        subject: '',
        content: '',
    };
    export default {
        name: 'NoDrewManage',
        components: {
            VueEditor
        },
        data: () => ({
            month: undefined,
            showMail: false,
            showManual: false,
            mailForm: {...defaultMail},
            mailRules: {
                subject: [
                    {required: true, message: '請輸入主旨!', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '請輸入內文!', trigger: 'blur'},
                ]
            },
            customToolbar: [
                [{header: [false, 1, 2, 3, 4, 5, 6]}],
                ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                [
                    {align: ''},
                    {align: 'center'},
                    {align: 'right'},
                    {align: 'justify'}
                ],
                ['blockquote', 'code-block'],
                [{list: 'ordered'}, {list: 'bullet'}, {list: 'check'}],
                [{indent: '-1'}, {indent: '+1'}], // outdent/indent
                [{color: []}, {background: []}], // dropdown with defaults from theme
                ['clean'] // remove formatting button
            ],
            manual: {},
            selectedDate: '',
            selectedPeriods: []
        }),
        computed: {
            ...mapState('manage', {
                forms: state => state.noDrewForms
            }),
            ...mapState('booking', {
                drawablePeriods: state => state.availableDrawablePeriodsInRange
            }),
            ...mapState(['setting']),
            availableMonths() {
                return this.setting.months.map(m => m.month);
            },
            availablePeriods() {
                const keys = Object.keys(this.drawablePeriods);
                return keys.reduce((obj, key) => {
                    const existed = this.manual[key] || [];
                    const avail = this.drawablePeriods[key]
                        .filter(p => !existed.some(e => e === this.fakeId(p)));
                    if (avail.length) {
                        return {...obj, [key]: avail}
                    }
                    return obj;
                }, {});
            },
            selectablePeriods() {
                const existed = this.manual[this.selectedDate] || [];
                return (this.availablePeriods[this.selectedDate] || [])
                    .filter(p => !existed.some(e => e === this.fakeId(p)));
            },
            manualResults() {
                const keys = Object.keys(this.manual);
                return keys.reduce((lst, k) => {
                   return lst.concat([
                       {
                           date : k,
                           drew : this.manual[k].map(p => this.fakeIdToObj(p))
                               .map(p => `${p.roomName}-${p.tag}`)
                               .join(', ')
                       }
                   ])
                }, []);
            }

        },
        mixins: [formTableMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            fakeId(period) {
                return `${period.id}_${period.roomId}_${period.tag}_${period.roomName}`;
            },
            fakeIdToObj(fakeId) {
                const [id, roomId, tag, roomName] = fakeId.split('_');
                return {id, roomId, tag, roomName};
            },
            ...mapActions('manage', {
                getForms: 'getNoDrewFormsAction',
                sendMail: 'sendNoDrewMailAction',
                addDrewManually: 'addDrewManuallyAction',
            }),
            ...mapActions('booking', {
                getAvailablePeriods: 'getAvailableDrawablePeriodsInRangeAction'
            }),

            onSelectDate(date) {
                this.selectedPeriods = [];
            },

            async onMonthChange() {
                await this.getForms(this.month);
            },

            async refresh() {
                await this.getForms(this.month);
            },
            async showMailDialog(row) {
                await this.select(row);
                this.showMail = true;
                this.mailForm.content = this.setting.sys.footer;
            },

            async showManualDialog(row) {

                await this.select(row);
                const {ncutRoomId, begin, end} = row;

                await this.getAvailablePeriods({
                    range: [begin, end],
                    ncutRoomId
                });
                this.showManual = true;
            },

            closeMailDialog() {
                this.resetMailForm();
            },

            closeManualDialog() {
                this.resetManualDialog();
            },

            resetManualDialog() {
                this.showManual = false;
                this.manual = {};
                this.selectedPeriods = [];
                this.selectedDate = '';
            },

            onManualDialogClosed() {
                this.resetManualDialog();
            },

            resetMailForm() {
                this.showMail = false;
                this.mailForm = {...defaultMail};
                this.$refs.mailForm.clearValidate();
            },
            onMailDialogOpened() {
                this.$refs.mailForm.clearValidate();
            },
            onMailDialogClosed() {
                this.resetMailForm();
            },

            onAdd() {
                if (this.selectedDate && this.selectedPeriods.length) {
                    const newManual = {...this.manual};
                    (newManual[this.selectedDate] = newManual[this.selectedDate] || [])
                        .push(...this.selectedPeriods);
                    this.manual = newManual;
                    this.selectedPeriods = [];
                    this.selectedDate = '';
                } else {
                    this.$message({
                        message: '請選擇日期及時段',
                        type: 'warning'
                    })
                }
            },

            async onAddSubmit(){
                if (this.manual && Object.keys(this.manual).length > 0) {
                    try {
                        await this.$confirm('確定要送出嗎?', {
                            type: 'warning',
                        });
                        const data =  Object.keys(this.manual).reduce((lst, k) => {
                            return lst.concat([
                                ...this.manual[k]
                                    .map(p => this.fakeIdToObj(p))
                                    .map(p => ({
                                        periodId: p.id,
                                        roomId: p.roomId,
                                        date: k,
                                        formId: this.selectedForm.id,
                                        month: this.month
                                    }))
                            ])
                        }, []);
                        const success = await this.addDrewManually(data);
                        if (success) {
                            this.$message.success('異動成功');
                            this.resetManualDialog();
                            //await this.refresh();
                        } else {
                            this.$message.warning('異動成功，請重試一次');
                        }
                    } catch (e) {
                        if (e !== 'cancel') {
                            this.$message({
                                type: 'error',
                                message: '發生錯誤，請重試一次!'
                            });
                        }
                    }

                } else {
                    this.$message({
                        message: '請至少選擇一個設定',
                        type: 'warning'
                    })
                }
            },

            async onSendMail() {
                const {mailForm: form} = this.$refs;
                await form.validate(async (valid) => {
                    if (valid) {
                        try {
                            await this.$confirm('確定要送出嗎?', {
                                type: 'warning',
                            });
                            const success = await this.sendMail({
                                ...this.mailForm,
                                id: this.selectedForm.id
                            });
                            if (success) {
                                this.$message({
                                    message: '寄送成功',
                                    type: 'info'
                                });
                                this.resetMailForm();
                            }
                        } catch (e) {
                            if (e !== 'cancel') {
                                this.$message({
                                    type: 'error',
                                    message: '發生錯誤，請重試一次!'
                                });
                            }
                        }
                    }
                });

            }
        },
        watch: {
            forms(current) {
                this.pagedForms = this.pageData(current, 1);
                this.currentPage = 1;
            },
            setting: {
                async handler(newSetting) {
                    if (newSetting && newSetting.months && newSetting.months[0]) {
                        await this.getForms(newSetting.months[0].month);
                        this.month = newSetting.months[0].month;
                    }
                },
                deep: true
            }
        },
        async created() {
            await this.getForms(this.availableMonths[0]);
            this.month = this.availableMonths[0];
        }
    }
</script>

<style>

</style>